enum ProductSubType {
    DepositFixedTerm = "DEPOSIT_FIXED_TERM",
    DepositNoticeAccount = "DEPOSIT_NOTICE",
    DepositSavingsAccount = "DEPOSIT_SAVINGS_ACCOUNT",
    DepositIndividualSavingsAccount = "DEPOSIT_INDIVIDUAL_SAVINGS_ACCOUNT",
    DepositCurrentAccount = "DEPOSIT_CURRENT_ACCOUNT",
    LendingFixedTerm = "LENDING_FIXED_TERM",
    LendingDynamicTerm = "LENDING_DYNAMIC_TERM",
    LendingInterestFree = "LENDING_INTEREST_FREE",
    LendingRevolvingCredit = "LENDING_REVOLVING_CREDIT",
}
export default ProductSubType